import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from "@angular/router";
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { loadingFade } from '../../animacoes';
import * as Datepicker from 'js-datepicker';
import * as moment from 'moment';

import { UsuarioService } from '../services/usuario.service';
import { AuthService } from '../services/auth.service';
import { ClienteService } from '../services/cliente.service';
import { UnidadeService } from '../services/unidade.service';
import { ProfissionalService } from '../services/profissional.service';
import { VeiculoService } from '../services/veiculo.service';
import { CheckMilimetragemService } from '../services/check-milimetragem.service';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-milimetragem-pneus-edit',
  templateUrl: './milimetragem-pneus-edit.component.html',
  styleUrls: ['./milimetragem-pneus-edit.component.css'],
	animations: [loadingFade]
})
export class MilimetragemPneusEditComponent implements OnInit {
  public loading;
  public submitting = false;
  public inicioPeriodo;

	public formChecklist: FormGroup;

  public agencias = [];
  public unidades = [];
  public profissionais = [];
  public veiculos = [];

  public check_milimetragem_id = null;
  public profissional = null;

  // datepickers
	private data_checklist_dp;

  //filtro
  public cliente_id___cliente = null;
  public unidade_id___unidade = null;
  public veiculo_id___veiculo = null;
  public check_milimetragem_turno___periodo = null;
  public check_milimetragem_status___status = null;
  public check_milimetragem_data___data_i = null;
  public check_milimetragem_data___data_f = null;
  public profissional_id___profissional = null;


  constructor(private authSvc: AuthService,
    private usuarioSvc: UsuarioService,
    private route: ActivatedRoute,
    private fb: FormBuilder,
    private router: Router,
    private clienteSvc: ClienteService,
    private unidadeSvc: UnidadeService,
    private profissionalSvc: ProfissionalService ,
    private veiculoSvc: VeiculoService,
    private checkMilimetragemSvc: CheckMilimetragemService) { }

  ngOnInit() {
    this.pegaAgencias();
    //this.pegaProfissionais();
    this.criaForm();
    this.verificaCliente();
    this.loading = true;

		this.route.params.subscribe( params => {
			if (params.id) {


        var splitFiltro = params.id.split("?");

        if(splitFiltro[1] !== undefined){
          
          var splitfiltro = splitFiltro[1].split("&");
          for (let f in splitfiltro) {

            var loSplitValor = splitfiltro[f].split("=");

            switch(loSplitValor[0]) { 
              case "cliente_id___cliente": { 
                 this.cliente_id___cliente = loSplitValor[1];
                 break; 
              } 
              case "unidade_id___unidade": { 
                this.unidade_id___unidade = loSplitValor[1];
                 break; 
              } 
              case "veiculo_id___veiculo": { 
                this.veiculo_id___veiculo = loSplitValor[1];
                 break; 
              } 
              case "check_milimetragem_turno___periodo": { 
                this.check_milimetragem_turno___periodo = loSplitValor[1];
                 break; 
              }     
              case "check_milimetragem_data___data_i": { 
                this.check_milimetragem_data___data_i = loSplitValor[1];
                 break; 
              }      
              case "check_milimetragem_data___data_f": { 
                this.check_milimetragem_data___data_f = loSplitValor[1];
                 break; 
              }      
              case "profissional_id___profissional": { 
                this.profissional_id___profissional = loSplitValor[1];
                 break; 
              }                                                            
           }

          }


        }  

				this.check_milimetragem_id = params.id;
				this.checkMilimetragemSvc.getCheckMilimetragem(params.id).then((data: any) => {
          this.pegaUnidadesByAgencia(data.cliente_id);
          this.pegaVeiculosByUnidade(data.unidade_id);
          this.pegaVeiculoUnidadeProfissional(data);
					this.preencheForm({
            check_milimetragem_id:  data.check_milimetragem_id,
            usuario_id:  data.usuario_id,
            check_milimetragem_data:  moment(data.check_milimetragem_data, 'YYYY-MM-DD').format('DD/MM/YYYY'),
            check_milimetragem_turno:  data.check_milimetragem_turno,
            cliente_id:  data.cliente_id,
            unidade_id:  data.unidade_id,
            profissional_id:  data.profissional_id,
            veiculo_id:  data.veiculo_id,
            check_milimetragem_ed_s1: this.formatMilimetragem(data.check_milimetragem_ed_s1),
            check_milimetragem_ed_s2: this.formatMilimetragem(data.check_milimetragem_ed_s2),
            check_milimetragem_ed_s3: this.formatMilimetragem(data.check_milimetragem_ed_s3),
            check_milimetragem_ed_s4: this.formatMilimetragem(data.check_milimetragem_ed_s4),
            check_milimetragem_et_s1: this.formatMilimetragem(data.check_milimetragem_et_s1),
            check_milimetragem_et_s2: this.formatMilimetragem(data.check_milimetragem_et_s2),
            check_milimetragem_et_s3: this.formatMilimetragem(data.check_milimetragem_et_s3),
            check_milimetragem_et_s4: this.formatMilimetragem(data.check_milimetragem_et_s4),
            check_milimetragem_dd_s1: this.formatMilimetragem(data.check_milimetragem_dd_s1),
            check_milimetragem_dd_s2: this.formatMilimetragem(data.check_milimetragem_dd_s2),
            check_milimetragem_dd_s3: this.formatMilimetragem(data.check_milimetragem_dd_s3),
            check_milimetragem_dd_s4: this.formatMilimetragem(data.check_milimetragem_dd_s4),
            check_milimetragem_dt_s1: this.formatMilimetragem(data.check_milimetragem_dt_s1),
            check_milimetragem_dt_s2: this.formatMilimetragem(data.check_milimetragem_dt_s2),
            check_milimetragem_dt_s3: this.formatMilimetragem(data.check_milimetragem_dt_s3),
            check_milimetragem_dt_s4: this.formatMilimetragem(data.check_milimetragem_dt_s4),
					});
					this.loading = false;
				});
			}
			else {
				this.loading = false;
			}
    });
  }
  criaForm(){
    
    this.formChecklist = this.fb.group({
      check_milimetragem_id: null,
			usuario_id: this.authSvc.getUsuarioId(),
      check_milimetragem_data: [moment().format('DD/MM/YYYY'), Validators.required],
      check_milimetragem_turno: [this.pegaPeriodo(), Validators.required],
      cliente_id: [null, Validators.required],
      unidade_id: [null, Validators.required],
      profissional_id: [this.profissional, Validators.required],
      veiculo_id: [null, Validators.required],
      check_milimetragem_ed_s1: null,
      check_milimetragem_ed_s2: null,
      check_milimetragem_ed_s3: null,
      check_milimetragem_ed_s4: null,
      check_milimetragem_et_s1: null,
      check_milimetragem_et_s2: null,
      check_milimetragem_et_s3: null,
      check_milimetragem_et_s4: null,
      check_milimetragem_dd_s1: null,
      check_milimetragem_dd_s2: null,
      check_milimetragem_dd_s3: null,
      check_milimetragem_dd_s4: null,
      check_milimetragem_dt_s1: null,
      check_milimetragem_dt_s2: null,
      check_milimetragem_dt_s3: null,
      check_milimetragem_dt_s4: null,
      
    });
    
    moment.locale('pt-Br');
    this.data_checklist_dp = Datepicker('#check_milimetragem_data', {
			customMonths: moment.months(),
			customDays: moment.weekdaysShort(),
			overlayPlaceholder: 'Preencha o ano',
			overlayButton: 'Enviar',
			formatter: (element, date) => {
				let formatted = moment(date).format('DD/MM/YYYY');
				this.formChecklist.controls['check_milimetragem_data'].setValue(formatted);
			}
    });

    if(this.authSvc.getPerfil() != 2){
      this.usuarioSvc.getUsuario(this.authSvc.getUsuarioId()).then((data: any) => {
        this.profissional = data.profissional_id;
        this.formChecklist.get('profissional_id').setValue(data.profissional_id);
        this.formChecklist.get('profissional_id').updateValueAndValidity();
        this.formChecklist.get('profissional_id').disable();
      });
    }

  }

  preencheForm(dados) {
		this.formChecklist.setValue(dados);
  }
  

  pegaPeriodo(){
    let hora = parseInt(moment().format('HH'));
    if(hora > 7  &&  hora < 19){
      return 'D';
    }
    else{
      return 'N';
    }
  }

  pegaAgencias(){
    this.clienteSvc.getClientesByUsuario(this.authSvc.getUsuarioId()).then((data: any) => {
      this.agencias = data;
    }).catch((err) => {
      console.log(err);
    });
  }

  pegaUnidadesByAgencia(agencia_id){
    this.unidadeSvc.getUnidadesByUsuarioAndCliente(this.authSvc.getUsuarioId(), agencia_id).then((data: any) => {
      this.unidades = data;
    }).catch((err) => {
      console.log(err);
    });
  }
  
  pegaVeiculosByUnidade(unidade_id){
    this.veiculoSvc.getByTipoVeiculo(unidade_id, 1).then((data: any[]) => {
      this.veiculos = data;
		}).catch((err) => {
			console.log(err);
		});
  }

  onChangeAgencia(e){
    this.formChecklist.controls.unidade_id.setValue(null);
    this.formChecklist.controls.veiculo_id.setValue(null);
    this.verificaCliente();
    this.unidadeSvc.getUnidadesByUsuarioAndCliente(this.authSvc.getUsuarioId(), e.cliente_id).then((data: any) => {
      this.unidades = data;
    }).catch((err) => {
      console.log(err);
    });
  }

  onChangeUnidade(e){
    this.veiculoSvc.getByTipoVeiculo(e.unidade_id, 1).then((data: any[]) => {
      this.veiculos = data;
		}).catch((err) => {
			console.log(err);
		});
  }

  pegaProfissionais(){
    this.profissionalSvc.getProfissionais().then((data: any[]) => {
			this.profissionais = data;
		}).catch((err) => {
			console.log(err);
		});
  }

  invalid(nome) {
    let input = this.formChecklist.get(nome);
		return input.touched && input.invalid;
  }
  
  verificaCliente() {
		if (this.formChecklist.get('cliente_id').value)
			this.formChecklist.get('unidade_id').enable();
		else
			this.formChecklist.get('unidade_id').disable();
	}
  
  enviaChecklist() {
    console.log(this.formChecklist.value);
    
    if (this.formChecklist.valid) {
      this.submitting = true;
      this.formChecklist.get('profissional_id').enable();
      let toSend = this.formChecklist.value;

      toSend.check_milimetragem_ed_s1 = toSend.check_milimetragem_ed_s1.replace(',','.');
      toSend.check_milimetragem_ed_s2 = toSend.check_milimetragem_ed_s2.replace(',','.');
      toSend.check_milimetragem_ed_s3 = toSend.check_milimetragem_ed_s3.replace(',','.');
      toSend.check_milimetragem_ed_s4 = toSend.check_milimetragem_ed_s4.replace(',','.');
      toSend.check_milimetragem_et_s1 = toSend.check_milimetragem_et_s1.replace(',','.');
      toSend.check_milimetragem_et_s2 = toSend.check_milimetragem_et_s2.replace(',','.');
      toSend.check_milimetragem_et_s3 = toSend.check_milimetragem_et_s3.replace(',','.');
      toSend.check_milimetragem_et_s4 = toSend.check_milimetragem_et_s4.replace(',','.');
      toSend.check_milimetragem_dd_s1 = toSend.check_milimetragem_dd_s1.replace(',','.');
      toSend.check_milimetragem_dd_s2 = toSend.check_milimetragem_dd_s2.replace(',','.');
      toSend.check_milimetragem_dd_s3 = toSend.check_milimetragem_dd_s3.replace(',','.');
      toSend.check_milimetragem_dd_s4 = toSend.check_milimetragem_dd_s4.replace(',','.');
      toSend.check_milimetragem_dt_s1 = toSend.check_milimetragem_dt_s1.replace(',','.');
      toSend.check_milimetragem_dt_s2 = toSend.check_milimetragem_dt_s2.replace(',','.');
      toSend.check_milimetragem_dt_s3 = toSend.check_milimetragem_dt_s3.replace(',','.');
      toSend.check_milimetragem_dt_s4 = toSend.check_milimetragem_dt_s4.replace(',','.');
      
      if (this.check_milimetragem_id === null) { // criar
        toSend.check_milimetragem_registro = moment().format('YYYY-MM-DD HH:mm:ss');

				this.checkMilimetragemSvc.criaCheckMilimetragem(toSend).then((data) => {
          console.log('resp', data);
          Swal.fire({
            type: 'success',
            title: 'Checklist cadastrado com sucesso!',
            onClose: ()=>{
          		this.router.navigate(['home/milimetragempneus']);
            }
          });
				}).catch(err => {
          console.log(err);
          this.submitting = false;
          Swal.fire({
            type: 'error',
            title: 'Ops! Algo de errado aconteceu!',
            text: 'Tente novamente mais tarde!'
          });
				});
			}
			else { // editar
				this.checkMilimetragemSvc.editaCheckMilimetragem(toSend).then((data) => {
          console.log('resp', data);
				  Swal.fire({
            type: 'success',
            title: 'Checklist alterado com sucesso!',
            onClose: ()=>{
          		this.router.navigate(['home/milimetragempneus']);
            }
          });
				}).catch(err => {
					console.log(err);
          this.submitting = false;
          Swal.fire({
            type: 'error',
            title: 'Ops! Algo de errado aconteceu!',
            text: 'Tente novamente mais tarde!'
          });
				});
			}
    }
    else{
      Swal.fire({
        type: 'error',
        title: 'Checklist incompleto!',
        text: 'Verifique os itens em vermelho!'
      });
      for( let field in this.formChecklist.controls){
        let campo = this.formChecklist.get(field);
        campo.markAsTouched();
      }
    }
    
  }

  formatMilimetragem(value){
    if(value == null){
      return null;
    }
    else{
      return value.replace('.',',');
    }
  }


  onChangeVeiculoUnidade(e){
    this.pegaVeiculoUnidadeProfissional(e);
	}

  pegaVeiculoUnidadeProfissional(e){
		  
      this.formChecklist.controls.veiculo_id.setValue(null);
      this.formChecklist.controls.profissional_id.setValue(null);
      this.loading = true;
			this.veiculos = []
			this.veiculoSvc.getByVeiculoUnidadeEspecialidade(e.unidade_id,"todos").then((data: any[]) => {
	
			let dados = [];
			for(let veiculo of data){
			  dados.push({
				veiculo_id: veiculo.veiculo_id,
				placa_numero: veiculo.veiculo_placa + ' - ' + veiculo.veiculo_numero,
				unidade_id: e.unidade_id,
				cliente_id: e.cliente_id
			  });
			}


			this.veiculos = dados;
			this.pegaProfissionaisClienteUnidade(e)
	
			this.loading = false;
		  }).catch((err) => {
			console.log(err);
		  });
  }

  pegaProfissionaisClienteUnidade(e){
		this.loading = true;
		
		this.profissionalSvc.getProfissionalEdit(e.cliente_id,e.unidade_id).then((data: any[]) => {
				this.profissionais = data;
	
		  this.loading = false;
			}).catch((err) => {
				console.log(err);
			});
	  }	


    
    onClickVoltar(){

      let params = 'cliente_id___cliente=' + this.cliente_id___cliente;
      params += "&unidade_id___unidade=" + this.unidade_id___unidade;
      params += "&veiculo_id___veiculo=" + this.veiculo_id___veiculo;
      params += "&check_milimetragem_turno___periodo=" + this.check_milimetragem_turno___periodo;
      params += "&check_milimetragem_data___data_i=" + this.check_milimetragem_data___data_i;
      params += "&check_milimetragem_data___data_f=" + this.check_milimetragem_data___data_f;
      params += "&profissional_id___profissional=" + this.profissional_id___profissional;
  
      this.router.navigate(['/home/milimetragempneusfiltro/' + params]);
  
    }

}
